import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../components/UI/Modal";
import { IRefundMediaFile } from "../../models/refunds";
import RefundAttachmentItem from "./RefundAttachmentItem";

interface IRefundAttachmentsModalProps {
  open: boolean;
  closeModal: () => void;
  mediaFiles: IRefundMediaFile[];
}

const translationPath = "page.refundsPage.";

const RefundAttachmentsModal = ({
  open,
  closeModal,
  mediaFiles,
}: IRefundAttachmentsModalProps) => {
  const { t } = useTranslation();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ModalComponent open={open} onClose={closeModal} dialogMaxWidth={"sm"}>
      <Box sx={{ width: matches ? "100%" : 420, maxWidth: "100%" }}>
        <Typography variant="h6" sx={{ mb: 1, mt: -1 }}>
          {t(translationPath + "attachments")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {mediaFiles.map((file) => (
            <RefundAttachmentItem key={file.id} file={file} />
          ))}
        </Box>
      </Box>
    </ModalComponent>
  );
};

export default RefundAttachmentsModal;
